<template>
  <div class="sku-action">
    <div class="action_tips" v-if="ordered && (extCode == 2 || extCode == 3)">
      <p>
        {{ orderedTips }}
      </p>
    </div>
    <div
      class="action_tips"
      :class="{
        'tips-vip': isVipFirstBuy && commodityVipFirst,
        'tips-vip-allow': isVipFirstBuy && commodityVipFirst && commodityVipFirst.vipAllowed,
        'tips-vip-notallow': isVipFirstBuy && commodityVipFirst && !commodityVipFirst.vipAllowed
      }"
      v-else-if="((floatTips && source != 20 && source != 21) || renewTip) && !ordered && !selectedRenewAndUnPublish"
    >
      <p v-if="params.isSpot && commodityDeposite && commodityDeposite.spotDepositDesc">
        {{ commodityDeposite.spotDepositDesc }}
      </p>
      <!-- 新增以旧换新提示文案 -->
      <p
        class="recycle"
        v-else-if="showRecycleBuyType && renewTip && !isFullPayBuy && !isVipFirstBuy && extCode != 4 && extCode != 1"
        :aria-label="renewTipAriaLabel"
      >
        {{ renewTip }}
      </p>
      <p v-else-if="source != 20 && source != 21">
        <template
          v-if="
            isShowLogistics &&
            logisticsMsg &&
            discountType !== 'fullpay' &&
            discountType !== 'deposit' &&
            !isVipFirstBuy
          "
        >
          {{ logisticsMsg }}。
        </template>
        {{ floatTips }}
      </p>
      <div
        class="vip-upgrade"
        v-if="
          !env.isPadVivoApp &&
          isVipFirstBuy &&
          commodityVipFirst &&
          !commodityVipFirst.vipAllowed &&
          commodityVipFirst.upLevelUrl
        "
        @click="goUpgrade"
      >
        升级会员
        <v-icon class="icon-right" name="arrow-right" />
      </div>
    </div>
    <div
      class="action_tips"
      v-else-if="source != 20 && source != 21 && isShowLogistics && logisticsMsg && !selectedRenewAndUnPublish"
    >
      <p>
        {{ logisticsMsg }}
      </p>
    </div>
    <div class="action_bar">
      <div class="btn-action btn-action--dark" v-if="showAddCart && !isCountDown" @click="addCart" role="button">
        <span class="text">加入购物车</span>
      </div>
      <div
        v-if="isCountDown"
        class="btn-action"
        :class="{
          'btn-action--depositcountdowm': isDepositBuy || isFullPayBuy,
          'btn-action--vipcountdowm': isVipFirstBuy
        }"
      >
        <span class="text">距开始</span>
        <v-count-down
          class="text"
          ref="count"
          :current="currentTime"
          :start="startTime"
          :end="ednTime"
          :startFun="refresh"
          :endFun="endFun"
        ></v-count-down>
      </div>
      <div
        v-else
        role="button"
        class="btn-action"
        :class="{
          'btn-action--darkgolden': discountType == 'vip',
          'btn-action--graygolden':
            discountType == 'vip' && ((isPreTimeVip && commodityVipFirst.vipAllowed) || vipFirstBuyDisable),
          'btn-action--purple': discountType == 'fullpay' || (discountType == 'deposit' && (!params.isSpot || !isSpot)),
          'btn-action--disabled': btnOption.isDisabled,
          'btn-action--isLightRed': isLightRed
        }"
        @click="confirm"
      >
        <span class="text">{{ btnOption.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatNumber } from '@/utils/common'
import { mapGetters, mapState, mapActions } from 'vuex'
import { vipFirstBuyPopup } from '@/components'
import env from '@/utils/clientEnv'
import { app } from '@/utils'

export default {
  name: 'SkuAction',
  props: {
    spuInfo: Object,
    skuInfo: Object,
    checkedInfo: Object,
    params: Object,
    floatTips: String,
    hasRecommend: Boolean,
    source: [Number, String], // 来源(1:已选模块;2:加入购物车;3:立即购买;4:领券购买;5:立即预约;6:一键拼团;7:立即秒杀;8:单独购买;9:镭雕;10:全款预定;11:定金预售;12:到货通知;13:现货购买)
    ordered: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      env: env
    }
  },
  computed: {
    ...mapGetters('detailv3', [
      'appointId',
      'isDepositBuy', //是否为定金预售
      'commodityDeposite', //定金预售信息
      'isFullPayBuy', //是否为全款预定
      'commodityFullPay', //全款预定信息
      'isShowLogistics',
      'isVipFirstBuy',
      'commodityVipFirst',
      'isPreTimeVip',
      'isSpot',
      'renewPriceLabel',
      'tradeInSkipLink',
      'isLinkActivity',
      'isUnpublish',
      'showRecycleBuyType'
    ]),
    ...mapState('detailv3', ['logisticsMsg', 'vipFirstBuyDisable']),
    // 商品类型，1：手机 2：配件 3：服务 4：虚拟商品
    goodsType() {
      return this.spuInfo?.commoditySpu?.cmmdyTypeId
    },
    // 优惠类型 vip,group,deposit,fullpay,quickbuy,bigpromotion,normal
    // 分别对应 会员,拼团,定金,全款,抢购,大促,正常
    discountType() {
      return this.skuInfo?.commoditySkuDiscount?.commodityDiscountType || 'normal'
    },
    // 异常编码 1：已售罄 2：立即预约 3：到货通知 4：下架
    extCode() {
      return this.skuInfo?.commoditySkuButton?.commodityExceptionCode || 0
    },
    // 查看推荐商品
    isSeeOther() {
      return (this.extCode == 1 || this.extCode == 4 || this.isGift) && this.hasRecommend
    },
    // 仅作为赠品
    isGift() {
      return this.spuInfo?.commoditySpu?.giftSign == 1
    },
    // 按钮是否置灰，当下架或缺货且没有推荐时需要置灰
    isGray() {
      return this.isGift || ((this.extCode == 1 || this.extCode == 4) && !this.hasRecommend)
    },
    // 来源是 20:一站式换新弹层;21:首页一站式换新楼层
    sourceIsRecycle() {
      return this.source == 20 || this.source == 21
    },
    // 是否展示加入购物车按钮
    showAddCart() {
      let { laser, fqNum } = this.checkedInfo
      return (
        this.checkedInfo.buyType != 2 &&
        this.source != 20 &&
        this.source != 21 &&
        this.goodsType != 3 &&
        this.goodsType != 4 &&
        this.skuInfo?.commoditySkuButton?.addShopCart == 1 &&
        this.source == 1 &&
        !this.spuInfo?.commoditySpu?.giftSign &&
        !laser &&
        !fqNum
      )
    },
    // 按钮文案
    btnOption() {
      let { laser, fqNum } = this.checkedInfo
      let text = this.source == 1 ? '立即购买' : '确定'
      let isDisabled = false
      if (this.isGift) {
        text = '仅作为赠品'
        isDisabled = true
        if (this.hasRecommend) {
          text = '查看推荐商品'
          isDisabled = false
        }
      } else if (this.discountType == 'group') {
        // 拼团按钮单独处理
        if (laser) {
          text = '添加赠言或个性图案'
        } else if (this.source == 8) {
          if (this.extCode) {
            if (this.isSeeOther) {
              text = '查看推荐商品'
            } else {
              text = this.skuInfo?.commoditySkuButton?.commodityMainButtonDesc
            }
            if ((this.extCode == 1 || this.extCode == 4) && !this.isSeeOther) {
              isDisabled = true
            }
          } else if (fqNum) {
            text = '分期购买'
          }
        } else if (this.source == 1) {
          // 只有拼购商详已选模块调起的才会显示一键开团，其他均为确定
          text = '一键开团'
        }
      } else if (this.discountType == 'fullpay' && this.source == 1) {
        text = laser ? '添加赠言或个性图案' : fqNum ? '分期购买' : '全款预定'
      } else if (this.discountType == 'deposit') {
        if (this.source == 1) {
          let obj = this.skuInfo.commoditySkuDiscount.commoditySkuDiscountDetail.commodityDeposite
          if (laser) {
            text = '添加赠言或个性图案'
          } else {
            text = `支付定金￥${formatNumber(obj.depositAmount)}`
            text = obj.depositSwellAmount ? text + `(抵￥${formatNumber(obj.depositSwellAmount)})` : text
          }
        }
        // 现货购买
        if (this.source == 13 && this.isSpot) {
          if (laser) {
            text = '添加赠言或个性图案'
          } else {
            text = '立即购买'
          }
        }
      } else if (this.discountType == 'vip') {
        if (this.source != 3) {
          text = this.skuInfo?.commoditySkuButton?.commodityMainButtonDesc
        }
        if (!this.isPreTimeVip && this.commodityVipFirst.vipAllowed)
          if (this.sourceIsRecycle) {
            text = '确定'
          } else if (this.checkedInfo.buyType == 2) {
            text = '立即换新'
          } else if (laser) {
            text = '添加赠言或个性图案'
          } else if (fqNum) {
            text = '分期购买'
          }

        if (this.isPreTimeVip && this.commodityVipFirst.vipAllowed) {
          isDisabled = true
        }
        if (this.vipFirstBuyDisable) {
          text = '当前商品已抢光'
          isDisabled = true
        }
      } else {
        if (this.extCode) {
          if (this.isSeeOther) {
            text = '查看推荐商品'
          } else {
            text = this.skuInfo?.commoditySkuButton?.commodityMainButtonDesc
          }
          if ((this.extCode == 1 || this.extCode == 4) && !this.isSeeOther) {
            isDisabled = true
          }
        } else if (this.sourceIsRecycle) {
          text = '确定'
        } else if (this.checkedInfo.buyType == 2) {
          text = '立即换新'
        } else if (laser) {
          text = '添加赠言或个性图案'
        } else if (fqNum) {
          text = '分期购买'
        } else if (this.source == 2 && this.hasAdditionCommodity) {
          text = '立即购买'
        }
      }
      if (this.extCode == 2 && this.ordered) text = '已预约'
      else if (this.extCode == 3 && this.ordered) text = '已登记'
      // 更换规格弹层场景 1: 以旧换新首页，其它: 商详页
      // 商详页唤起的更换规格与首页保持一致
      if (this.params?.refPage || this.sourceIsRecycle) {
        const commodityDiscountType = this.skuInfo?.commoditySkuDiscount?.commodityDiscountType // 商品营销活动状态编码
        if (this.isUnpublish) {
          // 待发布- 当前商品发布
          text = '当前商品待发布'
          isDisabled = true
        } else if (this.extCode) {
          // 商品状态异常编码【1：已售罄 - 当前商品已售罄 2：立即预约 - 当前商品预约中 3：到货通知 - 当前商品暂时缺货 4：当前商品已下架】
          const idx = this.extCode - 1
          text = ['当前商品已售罄', '当前商品预约中', '当前商品暂时缺货', '当前商品已下架'][idx]
          isDisabled = true
        } else if (commodityDiscountType === 'deposit') {
          // 定金预售
          text = '预售商品暂不支持'
          isDisabled = true
        } else {
          text = '确认'
          isDisabled = false
        }
      }
      return {
        text,
        isDisabled
      }
    },
    orderedTips() {
      if (this.ordered && this.extCode == 2) return '已成功预约，开始售卖时第一时间通知您！'
      else return '已成功登记，开始售卖时第一时间通知您！'
    },
    isLightRed() {
      return this.ordered && this.appointId
    },
    //当前时间
    currentTime() {
      return parseInt(this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.currentTime)
    },
    //开始时间
    startTime() {
      if (this.isVipFirstBuy) {
        //会员先享购
        return parseInt(this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityVipFirst?.startTime)
      } else if (this.isDepositBuy) {
        //定金预售
        return parseInt(
          this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite?.depositStartTime
        )
      } else if (this.isFullPayBuy) {
        //全款预定
        return parseInt(this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityFullPay?.startTime)
      } else {
        return 0
      }
    },
    //结束时间
    ednTime() {
      if (this.isVipFirstBuy) {
        //会员先享购
        return parseInt(this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityVipFirst?.endTime)
      } else if (this.isDepositBuy) {
        //定金预售
        return parseInt(
          this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityDeposite?.depositEndTime
        )
      } else if (this.isFullPayBuy) {
        //全款预定
        return parseInt(this.skuInfo?.commoditySkuDiscount?.commoditySkuDiscountDetail?.commodityFullPay?.endTime)
      } else {
        return 0
      }
    },
    //是否显示倒计时
    isCountDown() {
      if ((this.isVipFirstBuy || this.isDepositBuy || this.isFullPayBuy) && this.currentTime < this.startTime) {
        return true
      } else {
        return false
      }
    },
    // 选择了以旧换新但是商品为为发布状态
    selectedRenewAndUnPublish() {
      return (this.sourceIsRecycle || this.checkedInfo.buyType == 2) && this.isUnpublish
    },
    // 以旧换新补贴文案
    renewTip() {
      if (this.sourceIsRecycle || this.checkedInfo.buyType != 2) return ''
      return this.renewPriceLabel
    },
    // 以旧换新补贴文案 - 无障碍
    renewTipAriaLabel() {
      if (this.sourceIsRecycle || this.checkedInfo.buyType != 2) return ''
      return this.renewPriceArialLabel
    }
  },
  methods: {
    ...mapActions('detailv3', ['refresh', 'setCartAnimPosition']),
    endFun() {
      // 需要整个页面刷新，refresh只能刷新当前sku
      if (this.isVipFirstBuy) {
        window.location.replace(`/wap/product/${this.spuId}?skuId=${this.skuId}&channel=vip`)
      } else {
        this.refresh()
      }
    },
    // 加入购物车
    addCart() {
      console.log(`addCart:`, this.checkedInfo)
      this.$emit('clickTrack', '加入购物车')
      this.setCartAnimPosition()
      this.$emit('submit', { isAdd: true })
    },
    // 确定
    confirm() {
      this.$emit('clickTrack', this.btnOption?.text)
      // 会员先享购无库存
      if (this.vipFirstBuyDisable) {
        vipFirstBuyPopup({
          vipBuyStatus: 2,
          skuInfo: this.skuInfo,
          isTrackClick: true
        })
        return false
      }
      if (this.btnOption?.isDisabled) return false
      // 一键开团
      if (this.discountType == 'group' && this.source != 8) {
        return this.$emit('submit', {
          grouponId: this.params?.grouponId
        })
      }
      // 查看推荐商品
      if (this.isSeeOther) {
        return this.$emit('seeOther')
      }
      // 预约或到货通知
      if (this.extCode == 2 || this.extCode == 3) {
        return this.$emit('showAppointment', true)
      }
      if (this.isVipFirstBuy && !this.commodityVipFirst?.vipAllowed) {
        let spuId = this.spuInfo.commoditySpu.id
        let skuId = this.skuInfo.commoditySkuBaseInfo.skuId
        window.location.href = `/wap/product/${spuId}?skuId=${skuId}`
        return
      }

      // 加入购物车（不存在镭雕、分期、加购时、不是以旧换新购买方式）
      if (this.source == 2 && !this.checkedInfo.laser && !this.checkedInfo.fqNum && this.checkedInfo.buyType != 2) {
        return this.addCart()
      }

      // 一站式换新弹层优先级放在正常下单逻辑后面
      if (this.sourceIsRecycle) {
        this.confirmSpec()
        return
      }
      if (this.checkedInfo.buyType == 2) {
        if (this.isLinkActivity) {
          if (!this.tradeInSkipLink) return
          app.openNewWebview({
            url: this.tradeInSkipLink
          })
          return
        }
        this.goToRenew()
        return
      }
      this.$emit('submit', {
        isCommon: this.source == 8 || (this.params?.isSpot && this.isSpot), // 拼团的单独购买或定金预售中的现货购买走直接购买流程
        grouponId: this.params?.grouponId,
        isSpot: this.params?.isSpot && this.isSpot // 是否是定金预售中的现货购买
      })
    },
    goUpgrade() {
      let url = this.commodityVipFirst?.upLevelUrl
      url && (window.location.href = url)
    },
    // 以旧换新购买方式 - 立即换新 - 唤起换新弹层
    goToRenew() {
      this.$emit('goToRenew')
    },
    // 一站式换新更新规格 - 确认规格
    confirmSpec() {
      this.$emit('confirmSpec', this.checkedInfo)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-1 {
  .btn-action {
    line-height: 140px;
  }
}
.vivo-fontscale-2 {
  .btn-action {
    line-height: 130px;
  }
}
.vivo-fontscale-4 {
  .btn-action {
    line-height: 110px;
  }
}
.vivo-fontscale-5 {
  .btn-action {
    line-height: 100px;
  }
}
</style>
